import { Typography } from '@components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type CurrencyProps = {
  price: number;
  tag?: string;
};

export const CurrencyFormatter = ({ price, tag }: CurrencyProps) => {
  const { t } = useTranslation();
  if (!price && price !== 0) return <span>-</span>;
  const formattedPrice = new Intl.NumberFormat('nl-BE', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);

  return (
    <span>
      {formattedPrice}
      {tag && (
        <Typography tag="span" type="smallest">
          &nbsp;{t(tag)}
        </Typography>
      )}
    </span>
  );
};

export default CurrencyFormatter;
